import { useState } from 'react';
import { AdornmentInput } from '../../../components/Inputs/textField';
import SendMessageButton from './SendMessageButton';
import RippleAvatar from './loaders/RippleAvatar';
import './promptInput.scss';

interface PromptInputProps {
  value: string;
  placeholder: string;
  onChange: (value: string) => void;
  onSubmit: () => void;
  disabled?: boolean;
  isLoading?: boolean;
}

const PromptInput = ({
  value,
  placeholder,
  onChange,
  onSubmit,
  disabled = false,
  isLoading = false,
}: PromptInputProps) => {
  const [isFocused, setIsFocused] = useState(false);
  const isDisabled = disabled || isLoading || value.trim().length === 0;

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();

    if (isDisabled) {
      return;
    }

    onSubmit();
  };

  return (
    <form className="chat-prompt-input" onSubmit={handleSubmit}>
      <AdornmentInput
        value={value}
        onFocus={() => setIsFocused(true)}
        isFocused={isFocused}
        fixedAdornment={<RippleAvatar size="xs" />}
        placeholder={placeholder}
        onChange={onChange}
        disabled={disabled}
        multiline
        maxRows={6}
        className="w-100 chat-prompt-input__field"
      />
      <SendMessageButton active={!isDisabled} isLoading={isLoading} />
    </form>
  );
};

export default PromptInput;
